import { marked } from 'marked';
import DOMPurify from 'dompurify';

// Configure marked for safe, basic HTML output
marked.setOptions({
  breaks: true,
  gfm: true,
});

export function markdownToHtml(md) {
  if (!md) return '';
  const raw = marked.parse(md);
  // In browser environments, DOMPurify will sanitize against XSS
  return DOMPurify.sanitize(raw);
}
